"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerUIStatusValidation = void 0;
const CancelledReceiptValidation_1 = require("./CancelledReceiptValidation");
class ChargerUIStatusValidation {
    static isValid(entity) {
        // If entity.lost_focus_timestamp exists, validate that it has the correct type.
        if (entity.lost_focus_timestamp != undefined) {
            if (!(entity.lost_focus_timestamp instanceof Date))
                return false;
        }
        // Validate entity.mqtt_connects_since_last_boot for existence and correct type.
        if (entity.mqtt_connects_since_last_boot == undefined)
            return false;
        if (typeof entity.mqtt_connects_since_last_boot !== "number")
            return false;
        // Validate entity.cancelled_receipts for existence and correct type.
        if (entity.cancelled_receipts == undefined)
            return false;
        if (!Array.isArray(entity.cancelled_receipts))
            return false;
        if (!entity.cancelled_receipts.every((elem) => {
            if (!CancelledReceiptValidation_1.CancelledReceiptValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        // If entity.shows_offline exists, validate that it has the correct type.
        if (entity.shows_offline != undefined) {
            if (typeof entity.shows_offline !== "boolean")
                return false;
        }
        // If entity.page_load_timestamp exists, validate that it has the correct type.
        if (entity.page_load_timestamp != undefined) {
            if (!(entity.page_load_timestamp instanceof Date))
                return false;
        }
        return true;
    }
}
exports.ChargerUIStatusValidation = ChargerUIStatusValidation;
